import { useState, useEffect } from 'react'
import _ from 'lodash'
import { httpHandler, safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import errorHelper from '../../../../../lib/errorHelper'

const useBatchProposalById = (fetchBatchProposal, batch = {}, hasBatch, onError) => {
  const [isLoading, setIsLoading] = useState(false)
  const [batchProposal, setBatchProposal] = useState({})
  const [error, setError] = useState(null)
  const { id: batchId } = batch

  useEffect(() => {
    const trigger = async () => {
      if (_.isUndefined(batchId) || !hasBatch || !_.isEmpty(batchProposal)) {
        return
      }

      setIsLoading(true)
      const fetchBatchProposalParams = {
        fields: '+details',
        id: batchId
      }
      const [newError, newBatchProposal] = await safeAwait(
        fetchBatchProposal(fetchBatchProposalParams).then(httpHandler)
      )
      if (newError) {
        const errorMessage = errorHelper.parseErrorMessage(newError)
        setError(errorMessage)
        setIsLoading(false)
        onError && onError(errorMessage)
        return
      }

      setBatchProposal(newBatchProposal)
      setIsLoading(false)
    }
    trigger()
  }, [fetchBatchProposal, batchId, hasBatch, onError, batchProposal])

  return {
    isLoading,
    batchProposal,
    batch,
    error
  }
}

export default useBatchProposalById
